import { callDeleteApi, callGetApi, callPostApi, callPutApi } from "../interceptor";

// Get Super Admin Users List API function
export async function getSuperAdminUsers(data) {
  try {
    const response = await callPostApi({ url: "users/superadmin-list", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Add Super Admin User API function
export async function addSuperAdminUser(data) {
  try {
    const response = await callPostApi({ url: "users/create-superadmin", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Get Super Admin User By Id API function
export async function getSuperAdminUserById(id) {
  try {
    const response = await callGetApi({ url: `users/superadmin/${id}` });
    return response;
  } catch (error) {
    throw error;
  }
}

// Delete Super Admin User API function
export async function deleteSuperAdminUser(id) {
  try {
    const response = await callDeleteApi({ url: `users/delete-superadmin/${id}` });
    return response;
  } catch (error) {
    throw error;
  }
}

// Update Super Admin User API function
export async function updateSuperAdminUser(data) {
  try {
    const response = await callPutApi({ url: `users/update-superadmin/${data.id}`, body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateSuperAdminUserStatus(data) {
  try {
    const response = await callPutApi({ url: `users/update-user-status/${data.id}`, body: data });
    return response;
  } catch (error) {
    throw error;
  }
}